import { z } from 'zod';
import { NewsLandingPageSchema } from './NewsLandingPage';
import { NewsTopicSchema } from './NewsTopic';
import { NewsTopicPageSchema } from './NewsTopicPage';
import { NewsTagSchema } from './NewsTag';
import { NewsBasicPostSchema, NewsPostSchema } from './NewsPost';
import { MediaKitLandingPageSchema } from './MediaKitLandingPage';
import { JobListingPageSchema } from './JobListingPage';
import { LegalCookiePageSchema } from './LegalCookiePage';
import { LegalLandingPageSchema } from './LegalLandingPage';
import { LegalPageSchema } from './LegalPage';
import { LegalLicensesPageSchema } from './LegalLicensesPage';
import { FooterSchema } from './Footer';
import { NavigationSchema } from './Navigation';
import { LoadingScreenSchema } from './LoadingScreen';
import { LandingPageSchema } from './LandingPage';
import { PageTreeSchema } from './PageTree';
import { PageSchema } from './Page';
import { DocumentSchema } from './Document';
import { ExternalContentSchema } from './ExternalContent';

export * from './NewsLandingPage';
export * from './NewsPost';
export * from './NewsTopic';
export * from './NewsTopicPage';
export * from './NewsTag';
export * from './MediaKitLandingPage';
export * from './JobListingPage';
export * from './LegalCookiePage';
export * from './LegalLandingPage';
export * from './LegalPage';
export * from './LegalLicensesPage';
export * from './Footer';
export * from './Navigation';
export * from './LoadingScreen';
export * from './LandingPage';
export * from './PageTree';
export * from './Page';
export * from './Document';
export * from './ExternalContent';

export const SanityEntityUnion = z.union([
  NewsLandingPageSchema,
  NewsBasicPostSchema,
  NewsPostSchema,
  NewsTagSchema,
  NewsTopicSchema,
  NewsTopicPageSchema,
  FooterSchema,
  NavigationSchema,
  LandingPageSchema,
  LoadingScreenSchema,
  MediaKitLandingPageSchema,
  JobListingPageSchema,
  LegalCookiePageSchema,
  LegalLandingPageSchema,
  LegalPageSchema,
  LegalLicensesPageSchema,
  PageTreeSchema,
  PageSchema,
  DocumentSchema,
  ExternalContentSchema
]);
export type SanityEntity = z.infer<typeof SanityEntityUnion>;
